import React from 'react';
import styled from 'styled-components';
import { Link, TextStyle } from '@superops/ui-design-system';

import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const ProjectAndTicketIdCell = (props) => {
  const { cell } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;

  const projectOrTicketId =
    meta?.workItem?.displayId ||
    meta?.ticket?.displayId ||
    meta?.project?.displayId;

  const LinkMap = {
    PROJECT: 'PROJECT_DETAIL'
  };

  const module =
    meta?.workItem?.module || (meta?.project ? LinkMap.PROJECT : 'TICKET');

  const allProps = {
    module: LinkMap[module] || module,
    data: {
      [`${module.toLowerCase()}Id`]:
        meta?.workItem?.workId ||
        meta?.ticket?.ticketId ||
        meta?.project?.projectId
    }
  };

  const IconMap = {
    PROJECT: 'ProjectLogo',
    PROJECT_DETAIL: 'ProjectLogo',
    TICKET: 'TicketIdentifier',
    INVOICE: 'InvoiceIdentifier'
  };

  return projectOrTicketId ? (
    <div className="ellipsis flex center mw-100">
      <div className="fx actr opacity5 mr-10">
        <SVGIcon name={IconMap[module || 'TICKET']} />
      </div>
      <Link removeUnderline onClick={actions.onClick.bind(this, allProps)}>
        {projectOrTicketId}
      </Link>
    </div>
  ) : (
    <TextStyle variation="subdued">NA</TextStyle>
  );
};

export default ProjectAndTicketIdCell;
